import { render, staticRenderFns } from "./ApplyGradeTo.vue?vue&type=template&id=5922d273&"
import script from "./ApplyGradeTo.vue?vue&type=script&lang=js&"
export * from "./ApplyGradeTo.vue?vue&type=script&lang=js&"
import style0 from "./ApplyGradeTo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports